// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from './router/axios'

Vue.config.productionTip = false
Vue.config.ignoredElements = ['wx-open-launch-weapp']

// Vue.use(axios)
/* eslint-disable no-new */

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面meta */
  if(to.meta.content){
    let head = document.getElementsByTagName('head');
    let meta = document.createElement('meta');
    document.querySelector('meta[name="keywords"]').setAttribute('content', to.meta.content.keywords)
    document.querySelector('meta[name="description"]').setAttribute('content', to.meta.content.description)
    meta.content = to.meta.content;
    head[0].appendChild(meta)
  }
  next()
});

import '../static/reset.css'
import './assets/iconfont/iconfont.css'
import './assets/icon/iconfont.css'
import './assets/logo/search/iconfont.js'
import './assets/logo/life/iconfont.js'
import VueAwesomeSwiper from 'vue-awesome-swiper'
// import style (>= Swiper 6.x)
// import 'swiper/swiper-bundle.css'
// import Swiper, { Navigation, Pagination } from 'swiper';
// Swiper.use([Navigation, Pagination]);
Vue.use(VueAwesomeSwiper, /* { default options with global component } */)
Vue.config.productionTip = false


import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

import store from './store'

new Vue({
  el: '#app',
  router,
  store, //注册组件
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js